export enum TradingSessionID {
  /** Day */
  Day = '1',
  /** HalfDay */
  HalfDay = '2',
  /** Morning */
  Morning = '3',
  /** Afternoon */
  Afternoon = '4',
  /** Evening */
  Evening = '5',
  /** After-hours */
  AfterHours = '6',
  /** Holiday */
  Holiday = '7',
}
